import React from "react";

export default function Cardforwork(props) {
  return (
    <div>
      <div className="card shadow card-project">
        {props.imgsrc && (
          <img
            src={props.imgsrc}
            className="card-img-top"
            alt="img-tictactoe"
          />
        )}
        <div className="card-body">
          <h5 className="card-title">
            <strong>{props.title}</strong>
          </h5>

          <p className="card-text text-muted">{props.about}</p>

          <h6>
            <i class="ri-verified-badge-line iconf"></i> {props.tech}
          </h6>

          <a href={props.weburl} target="blank" className="btn">
            View
          </a>
        </div>
      </div>
    </div>
  );
}
